"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Facts_1 = require("../../facts/Facts");
var RugbyLeagueSpecificFact;
(function (RugbyLeagueSpecificFact) {
    RugbyLeagueSpecificFact["TRY"] = "TRY";
    RugbyLeagueSpecificFact["DROP_GOAL"] = "DROP_GOAL";
    RugbyLeagueSpecificFact["GOAL_KICK_SCORED"] = "GOAL_KICK_SCORED";
    RugbyLeagueSpecificFact["GOAL_KICK_MISSED"] = "GOAL_KICK_MISSED";
    RugbyLeagueSpecificFact["PENALTY_GOAL"] = "PENALTY_GOAL";
    RugbyLeagueSpecificFact["PENALTY_TRY"] = "PENALTY_TRY";
})(RugbyLeagueSpecificFact = exports.RugbyLeagueSpecificFact || (exports.RugbyLeagueSpecificFact = {}));
exports.rugbyLeaguePlayerFacts = [
    RugbyLeagueSpecificFact.TRY,
    RugbyLeagueSpecificFact.DROP_GOAL,
    RugbyLeagueSpecificFact.GOAL_KICK_SCORED,
    RugbyLeagueSpecificFact.GOAL_KICK_MISSED,
    RugbyLeagueSpecificFact.PENALTY_GOAL,
    RugbyLeagueSpecificFact.PENALTY_TRY,
    Facts_1.SubstitutionFact.SUBSTITUTION
];
//# sourceMappingURL=Facts.js.map